<template>
	<div class="footer">
		<div class="foot-left">
			<img class="cfes-logo" src="http://cfes.oss-cn-beijing.aliyuncs.com/img/logo2.png" alt="" />
			<div class="foot-left-con">
				<div class="foot-left-info">
					<div class="foot-phone">
						<div class="cfes-phone__enterprise" style="border: none">
							<h5>品牌咨询：</h5>
							<p>159-0040-5050</p>
						</div>
						<div class="cfes-phone__consult">
							<h5></h5>
							<p></p>
						</div>
					</div>
					<div class="cfes-address">上海市黄浦区徐家汇路560号</div>
					<div class="cfes-copyright">版权归属：上海橙风而上品牌设计有限公司<br>沪 ICP 备 2024071498 号</div>
				</div>
				<div class="cfes-qrcode">
					<img src="http://cfes.oss-cn-beijing.aliyuncs.com/img/QRcode.png" alt="" />
					<div>
						<h5>扫码获得VIP权益</h5>
						<ul>
							<li>免费项目诊断</li>
							<li>免费获取报价</li>
							<li>免费专业指导</li>
							<li>获取参考案例</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="foot-right">
			<div class="cfes-link-item">
				<h4>品牌策划</h4>
				<ul>
					<li>品牌策略</li>
					<li>产品定位</li>
					<li>战略诊断</li>
					<li>行业调研</li>
					<li>市场定位</li>
					<li>核心价值</li>
					<li>架构梳理</li>
				</ul>
			</div>
			<div class="cfes-link-item">
				<h4>识别系统</h4>
				<ul>
					<li>logo设计</li>
					<li>基础规范</li>
					<li>应用规范</li>
					<li>品牌主KV</li>
					<li>超级符号</li>
					<li>IP形象</li>
					<li>商标注册</li>
				</ul>
			</div>
			<div class="cfes-link-item">
				<h4>营销工具</h4>
				<ul>
					<li>宣传画册</li>
					<li>PPT介绍</li>
					<li>官网建设</li>
					<li>品牌视频</li>
					<li>包装设计</li>
					<li>私域营销</li>
					<li>礼品定制</li>
				</ul>
			</div>
			<div class="cfes-link-item">
				<h4>品牌空间</h4>
				<ul>
					<li>展会展台</li>
					<li>企业展厅</li>
					<li>工厂环境</li>
					<li>办公空间</li>
					<li>终端设计</li>
					<li>墙面设计</li>
					<li>导视系统</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "footerNav",
		components: {},
		data() {
			return {}
		},
		created() {},
		mounted() {},
		computed: {},
		watch: {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.footer {
		display: flex;
		padding: 4.75rem 8.35rem;
		background-color: #000;
		color: #FFF;

		.foot-left {
			width: 48.5rem;

			.cfes-logo {
				width: 13.2rem;
			}

			.foot-left-con {
				border-top: 1px solid #A2A2A2;
				border-bottom: 1px solid #A2A2A2;
				display: flex;
				margin-top: 1.5rem;
				padding-bottom: 0.8rem;

				.foot-left-info {

					.foot-phone {
						display: flex;
						margin: 1rem 0 0.7rem;

						.cfes-phone__enterprise,
						.cfes-phone__consult {
							width: 10rem;
							padding: 0.45rem 0 0.6rem;
							flex: 1;

							h5 {
								margin-bottom: 0.375rem;
								font-size: 0.75rem;
							}

							p {
								font-weight: bold;
								font-size: 0.95rem;
								letter-spacing: 0.125rem;
							}
						}

						.cfes-phone__enterprise {
							border-right: 0.05rem solid #A2A2A2;
						}

						.cfes-phone__consult {
							margin-left: 1.125rem;
						}
					}

					.cfes-address {
						font-size: 0.8rem;
						line-height: 1.4rem;
					}

					.cfes-copyright {
						font-size: 0.675rem;
						color: #A2A2A2;
						line-height: 1.15rem;
						letter-spacing: 0.025rem;
					}
				}

				.cfes-qrcode {
					display: flex;
					align-items: center;
					margin-top: 2rem;
					margin-left: 7.25rem;

					img {
						width: 5.75rem;
						height: 5.75rem;
						margin-right: 0.95rem;
					}

					h5 {
						font-size: 1rem;
						margin-bottom: 1rem;
						letter-spacing: 0.125rem;
					}

					ul {
						display: flex;
						flex-wrap: wrap;
						justify-content: space-between;
						padding: 0;
						list-style: none;

						li {
							font-size: 0.775rem;
							line-height: 1.7rem;
							position: relative;
							padding-left: 0.625rem;
							letter-spacing: 0.05rem;

							&::before {
								position: absolute;
								content: '';
								width: 0.2rem;
								height: 0.2rem;
								border-radius: 50%;
								left: 0.05rem;
								display: block;
								top: 50%;
								transform: translate(0, -50%);
								background-color: #FFF;
							}
						}
					}
				}
			}
		}

		.foot-right {
			flex: 1;
			display: flex;
			justify-content: space-between;
			margin-left: 10.875rem;
			margin-top: 0.5rem;

			.cfes-link-item {
				h4 {
					font-size: 0.875rem;
					position: relative;
					padding-bottom: 1.325rem;
					margin-bottom: 0.85rem;

					&::after {
						position: absolute;
						content: '';
						display: block;
						left: 0;
						bottom: 0;
						width: 0.625rem;
						height: 0.05rem;
						background-color: #FFF;
					}
				}

				li {
					font-size: 0.675rem;
					line-height: 1.675rem;
				}

			}
		}
	}
</style>
